import { FormSection } from "~/screens/Scheduling/PersonalInformation/components/form-section";
import { SubmissionCardSwitch } from "~/screens/Scheduling/PersonalInformation/components/insurance-submission-switch";
import { useVisitFormContext } from "~/screens/Scheduling/PersonalInformation/components/VisitForm/visit-form";
import { AddressSection } from "~/screens/Scheduling/PersonalInformation/components/VisitForm/visit-form-sections";
import {
  FILL_OPTION,
  FILL_SWITCH_OPTIONS,
} from "~/services/scheduling/constants";

export const FollowUpAddressSection = () => {
  const {
    form: {
      setValue,
      watch,
      formState: { errors },
    },
  } = useVisitFormContext();
  const fillAddressInfo = watch("fillAddressInfo");
  const error = errors.fillAddressInfo?.message;

  return (
    <FormSection title="HOME ADDRESS">
      <SubmissionCardSwitch
        options={Object.values(FILL_SWITCH_OPTIONS)}
        label="Has the patient's home address changed since their last visit?*"
        switchVariant="secondary"
        selectedOption={fillAddressInfo}
        onChange={(selected) =>
          setValue("fillAddressInfo", selected, { shouldValidate: true })
        }
        error={typeof error === "string" ? error : undefined}
      />
      {fillAddressInfo === FILL_OPTION.NOW && (
        <AddressSection hideSectionTitle />
      )}
    </FormSection>
  );
};
